import { useState, type FC } from "react";
import ImageContainer from "../../components/general/ImageContainers/ImageContainer";
import Tabs from "../../components/general/Tabs";
import type { TabGroupTabsProps } from "../../components/general/Tabs/components/TabGroup/TabGroup";
import * as s from "./TabModule.module.scss";

type TabModuleProps = {
	headline: string;
	image: { src: string; alt?: string };
	tabs: TabGroupTabsProps;
};

const TabModule: FC<TabModuleProps> = ({ headline, image, tabs }) => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);

	const tabImages = tabs.map((tab) => tab.image);

	return (
		<div className={s.container}>
			<h2 className={s.headline}>{headline}</h2>
			<div className={s.image}>
				<ImageContainer
					imgSrc={tabImages[selectedTabIndex]?.filename ?? image.src}
					alt={tabImages[selectedTabIndex]?.alt ?? image.alt ?? headline}
					ratio="square"
					sizes="(max-width: 768px) 80vw, 35vw"
				/>
			</div>
			{tabs.length > 0 && (
				<Tabs
					tabs={tabs}
					selectedTabIndex={selectedTabIndex}
					setSelectedTabIndex={setSelectedTabIndex}
				/>
			)}
		</div>
	);
};

export default TabModule;
